<template>
  <div>
    <Hero image="banner-home.jpeg" layout="md" title="Ocorreu um problema" class="darker" />

    <div class="row pb-5">
      <div class="col-12 col-lg-8 mx-auto mt-n4">
        <div class="bg-white shadow-sm p-5">
          <div class="d-flex align-items-center justify-content-center">
            <alert-circle-outline-icon style="font-size:120px;" class="text-wl-primary"/>
            <h4 class="m-3 text-muted font-weight-normal">
              {{ username }},
              <br>Ocorreu um problema na sua candidatura.
              <br>Tente novamente!
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from "@/components/media/Hero.vue";
import AlertCircleOutlineIcon from "vue-material-design-icons/AlertCircleOutline.vue";

export default {
  name: "SubscriptionErrorReturn",

  computed: {
    opportunity() {
      return this.$route.query.vaga;
    },

    username() {
      return this.$store.state.user.profile.name.split(" ")[0];
    }
  },

  components: {
    Hero,
    AlertCircleOutlineIcon
  }
};
</script>

<style lang="scss"></style>